<template>
    <div style="background: #eee; margin-top: 10px">
        <index-page></index-page>
    </div>
</template>

<script>
export default {
    data: function () {
        return {};
    },
    created() {
        var token = sessionStorage.getItem('userToken');
        if (token == null) {
            this.$router.push('/login');
        }
        // this.getBgImg();
    },
    methods: {}
};
</script>

<style scoped>
</style>